import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { PrintableFormatImageContainerModel } from '../../../../../models/aggregates/print';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import { PrintableFormatCriteriaModelQuery, PrintableFormatQueryCriteriaClass } from '../../criteria';
import { Observable } from 'rxjs';
import { Pagination } from '../shared/pagination.model';

@Injectable({
  providedIn: 'root'
})
export class PrintableFormatImageService extends BaseApiTemplateService<PrintableFormatImageContainerModel> {

  readonly subUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PRINT_PREFIX + 'printable-format/image-hdrs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.subUrl;
    this.endpoint_path = this.subUrl;
    this.httpClient = http;
  }
  // ----------------------------  files related endpoints -----------------------------------------
  replaceFile(formData: FormData, extGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/' + extGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<PrintableFormatImageContainerModel>>(url, formData, this.getHttpHeader(visa));
  }

  getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/pub/file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/pub/file/' + extGuid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
}
